// eslint-disable-next-line import/no-anonymous-default-export
export default /* glsl */`

// create variables of the base UV map for different maps

#ifdef USE_MAP
	varying vec2 mapUv;
#endif

#ifdef USE_BUMPMAP
	varying vec2 bumpMapUv;
#endif

varying vec2 normalMapUv;

#ifdef USE_ALPHAMAP
	varying vec2 alphaMapUv;
#endif

#ifdef USE_EMISSIVEMAP
	varying vec2 emissiveMapUv;
#endif

#ifdef USE_ROUGHNESSMAP
	varying vec2 roughnessMapUv;
#endif

#ifdef USE_METALNESSMAP
	varying vec2 metalnessMapUv;
#endif

`;